import Joi from 'joi-browser';

export default {
  images: Joi.array()
    .label('Imágenes'),
};



// WEBPACK FOOTER //
// ./src/containers/Admin/Configuration/validation.js